import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import GeneralHelper from './helpers/general';

import rootReducer from './reducers';

const basename = process.env.NODE_ENV === 'development' ? '/' : '/path/app';

const _history = createBrowserHistory({ basename });

// FIXME - add debug mode
const debugMode = history => {
	const test = path => {
		const query = GeneralHelper.getParamsFromUrl();
		const isDebugMode = query?.debug && query.debug === 'true';

		if (!isDebugMode) return path;

		const [pathname, search] = path.split('?');

		const params = new URLSearchParams(search || '');
		params.set('debug', 'true');

		return `${pathname}?${params.toString()}`;
	};
	return new Proxy(history, {
		get(obj, prop) {
			if (prop === 'push' || prop === 'replace') {
				return (path, state) => {
					// console.log(path);
					return obj[prop](test(path), state);
				};
			}

			if (typeof obj[prop] === 'function')
				return obj[prop].bind(obj);

			return obj[prop];
		}
	});
};

export const history = debugMode(_history);
// FIXME - (END) add debug mode

// Initialize store
let store;

// Return a function so we can configure it
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
	if (store) {
		return store;
	}

	const initialState = {};
	const enhancers = [];
	const middleware = [thunk, routerMiddleware(history)];

	// if (['local', 'testing', 'testing2'].indexOf(process.env.NODE_ENV) !== -1) {
	// 	const devToolsExtension = window.devToolsExtension;

	// 	if (typeof devToolsExtension === 'function') {
	// 		enhancers.push(devToolsExtension());
	// 	}
	// }

	// enhancers
	const composedEnhancers = compose(
		applyMiddleware(...middleware),
		// devtools redux
		(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'testing2')
			&& window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
			window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__() : compose(),
		...enhancers
	);

	// create store
	store = createStore(rootReducer(history), initialState, composedEnhancers);

	return store;
};
